import React, { useState, useEffect } from "react";
import { getAccessToken } from "../../services/authApi";
import { fieldReader, fieldWriter, createTask } from "../../services/loanApi";
import Modal from '../shared/Modal';
import Loading from "../layout/Loading";
import { info, error as logAppInsightError } from '../../utils/logger';
import { logError } from "../../utils/logError";
import '../../common.css';

const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;


const isConsumerLoan = (loanTypeValue) =>
    loanTypeValue?.toLowerCase().includes("consumer");
// Reusable grid for reason checkboxes
const ReasonGrid = ({ reasons, onChange, readOnly, loanTypeValue }) => {
    // Use the isConsumerLoan function to determine if the loan is consumer type
    const isConsumer = isConsumerLoan(loanTypeValue);

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
            {/* Column 1 */}
            <div className="flex flex-col space-y-2">
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="totalLoanAmount" checked={!!reasons.totalLoanAmount} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Loan Amount</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="appraisedValue" checked={!!reasons.appraisedValue} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Appraised Value</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="program" checked={!!reasons.program} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Program</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="term" checked={!!reasons.term} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Term</span>
                </label>
            </div>
            {/* Column 2 */}
            <div className="flex flex-col space-y-2">
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="rate" checked={!!reasons.rate} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Rate</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="loanPurpose" checked={!!reasons.loanPurpose} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Loan Purpose</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="propertyType" checked={!!reasons.propertyType} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Property Type</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="occupancy" checked={!!reasons.occupancy} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Occupancy</span>
                </label>

            </div>
            {/* Column 3 */}
            <div className="flex flex-col space-y-2">
                {/* <label className="flex items-center space-x-2">
                    <input type="checkbox" name="transferTaxes" checked={!!reasons.transferTaxes} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Transfer Taxes</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="mortgageInsurance" checked={!!reasons.mortgageInsurance} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Mortgage Insurance</span>
                </label> */}
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="salesPrice" checked={!!reasons.salesPrice} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Sales Price</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="recordingFees" checked={!!reasons.recordingFees} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Recording Fees</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input type="checkbox" name="other" checked={!!reasons.other} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                    <span className="form-label mb-1 w-50 alignment-checkbox">Other</span>
                </label>
                {isConsumer && (
                    <label className="flex items-center space-x-2">
                        <input type="checkbox" name="lenderborrowerPaid" checked={!!reasons.lenderborrowerPaid} onChange={onChange} readOnly={readOnly} disabled={readOnly} className="form-checkbox text-blue-600" />
                        <span className="form-label mb-1 w-50 alignment-checkbox">Lender/Borrower Paid</span>
                    </label>
                )}
            </div>
        </div>
    );
};
const LoanChangeFormUpdated = () => {

    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(null);
    const [loanId, setLoanId] = useState(null);
    const [loanNumber, setLoanNumber] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState(false);
    const [approvalDate, setApprovalDate] = useState(false);
    const [requestChangeDate, setRequestChangeDate] = useState('');
    const [requestHistory, setRequestHistory] = useState('');
    const [errorMessages, setErrorMessages] = useState({ reasons: "", dateOfChange: "", notes: "" });
    const [status, setStatus] = useState(null);
    const [userName, setUserName] = useState("");
    const [borrowerOptions, setBorrowerOptions] = useState([]);
    const [loanTypeValue, setLoanTypeValue] = useState('');
    const [formData, setFormData] = useState({
        reasons: {
            rate: false,
            //eligibilityChange: false,
            totalLoanAmount: false,
            program: false,
            recordingFees: false,
            // transferTaxes: false,
            appraisedValue: false,
            loanPurpose: false,
            // mortgageInsurance: false,
            propertyType: false,
            other: false,
            term: false,
            occupancy: false,
            salesPrice: false,
            lenderborrowerPaid: false,
        },
        loanNumber: '',
        borrowerName: '',
        dateOfChange: new Date().toISOString().split('T')[0],
        notes: '',
    });

    useEffect(() => {
        const initialize = async () => {
            if (window.elli && window.elli.script && window.elli.script.guest) {
                window.elli.script.guest.create();

                await initializeAuthObject(); // Wait for status to load
            } else {
                console.warn("elli.script.guest is not available.");
                setLoading(false); // Only set to false after everything loads
            }

        };
        initialize();
    }, []);


    const initializeAuthObject = async () => {
        try {
            window.elli.script.getObject("loan").then(async function (loanObject) {
                loanObject.all().then(async function (loan) {

                    setLoanId(loan.id);
                    setLoanNumber(loan.loanNumber);
                    const applications = loan.applications || [];
                    const borrowerOptions = applications.map((app, index) => {
                        const borrowerName = app?.borrower?.fullName || '';
                        const borrowerLegacyId = app?.borrower?.legacyId || '';
                        const hasCo = !!app?.coborrower?.fullName;

                        let displayName = borrowerName || `Application ${index + 1}`;
                        if (hasCo) {
                            displayName = `${borrowerName} & ${app.coborrower.fullName}`;
                        }

                        return {
                            label: displayName,
                            value: index.toString(), // store index
                            legacyId: borrowerLegacyId,
                            borrowerName: displayName,
                            refNumber: app?.creditReportReferenceIdentifier || '',
                            hasCoborrower: hasCo
                        };
                    });
                    setBorrowerOptions(borrowerOptions);

                    // Populate loan number and borrower name in formData on load
                    setFormData(prev => ({
                        ...prev,
                        loanNumber: loan.loanNumber || '',
                        borrowerName: borrowerOptions.length > 0 ? borrowerOptions[0].borrowerName : ''
                    }));
                    await getToken(false);
                    // Read all relevant custom fields for pending/approved
                    const tpoAuthObject = await window.elli.script.getObject("auth");
                    const authCode = await tpoAuthObject.createAuthCode();
                    const reToken = await getAccessToken(authCode);
                    const allFieldIds = [
                        "CX.COC.APPROVAL.DATE",
                        "CX.COC.CHANGEDATE",
                        "CX.COC.APPROVAL.HISTORY",
                        "CX.COC.REASON.RATELOCK",
                        "CX.COC.REASON.LOANAMOUNT",
                        "CX.COC.REASON.LOANPROGRAM",
                        "CX.COC.REASON.FEEUPDATE",
                        // "CX.COC.REASON.TRANSFERTAX",
                        "CX.COC.REASON.APPRAISEDVAL",
                        "CX.COC.REASON.LOANPURPOSE",
                        // "CX.COC.REASON.MORTGAGEINS",
                        "CX.COC.REASON.PROPERTYTYPE",
                        "CX.COC.REASON.OTHER",
                        "CX.COC.REASON.TERM",
                        "CX.COC.REASON.OCCUPANCY",
                        "CX.COC.REASON.SALESPRICE",
                        "CX.COC.COMMENTS",
                        "CX.COC.REQ.BY",
                        "CX.LOAN.TYPE",
                        "CX.COC.REASON.LENBORRPAID"
                    ];
                    const fieldResponse = await fieldReader(reToken, allFieldIds, loan.id);

                    const approval = fieldResponse["CX.COC.APPROVAL.DATE"];
                    const request = fieldResponse["CX.COC.CHANGEDATE"];
                    setLoanTypeValue(fieldResponse["CX.LOAN.TYPE"] || '');
                    setApprovalDate(approval);
                    setRequestChangeDate(request);
                    setRequestHistory(fieldResponse["CX.COC.APPROVAL.HISTORY"]);
                    // Determine status
                    let newStatus = "new";
                    if (request !== "//" && approval !== "//") {
                        newStatus = "approved";
                    } else if (request !== "//") {
                        newStatus = "pending";
                    }
                    setStatus(newStatus);

                    // If pending, populate formData with submitted values
                    if (newStatus === "pending") {
                        setFormData(prev => ({
                            ...prev,
                            dateOfChange: fieldResponse["CX.COC.CHANGEDATE"] && fieldResponse["CX.COC.CHANGEDATE"] !== "//" ? fieldResponse["CX.COC.CHANGEDATE"] : prev.dateOfChange,
                            notes: fieldResponse["CX.COC.COMMENTS"] || "",
                            reasons: {
                                rate: fieldResponse["CX.COC.REASON.RATELOCK"] === "Y",
                                totalLoanAmount: fieldResponse["CX.COC.REASON.LOANAMOUNT"] === "Y",
                                program: fieldResponse["CX.COC.REASON.LOANPROGRAM"] === "Y",
                                recordingFees: fieldResponse["CX.COC.REASON.FEEUPDATE"] === "Y",
                                // transferTaxes: fieldResponse["CX.COC.REASON.TRANSFERTAX"] === "Y",
                                appraisedValue: fieldResponse["CX.COC.REASON.APPRAISEDVAL"] === "Y",
                                loanPurpose: fieldResponse["CX.COC.REASON.LOANPURPOSE"] === "Y",
                                // mortgageInsurance: fieldResponse["CX.COC.REASON.MORTGAGEINS"] === "Y",
                                propertyType: fieldResponse["CX.COC.REASON.PROPERTYTYPE"] === "Y",
                                other: fieldResponse["CX.COC.REASON.OTHER"] === "Y",
                                term: fieldResponse["CX.COC.REASON.TERM"] === "Y",
                                occupancy: fieldResponse["CX.COC.REASON.OCCUPANCY"] === "Y",
                                salesPrice: fieldResponse["CX.COC.REASON.SALESPRICE"] === "Y",
                                lenderborrowerPaid: fieldResponse["CX.COC.REASON.LENBORRPAID"] === "Y",
                            }
                        }));
                    }

                    setLoading(false);
                });

                const tpoAuthObject = await window.elli.script.getObject("auth");
                tpoAuthObject.getUser().then(async function (user) {
                    const userData = user;
                    if (!userData) return;
                    const userFullName = `${user['firstName']} ${user['lastName']}`;
                    setUserName(userFullName);
                });
            });
        } catch (error) {
            console.error("Auth block Error:", error);
            logAppInsightError("InitializeAuthObject Error", error)
        }
    };

    // Cancel handler to clear custom fields
    const handleCancel = async () => {
        setLoading(true);
        try {
            // Build previous history
            const prevHistory = "\n" + requestHistory + "\n" || "";

            // Build timestamp
            const now = new Date();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const year = now.getFullYear();
            let hours = now.getHours();
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            const hoursStr = String(hours).padStart(2, '0');
            const timestamp = `${month}/${day}/${year} ${hoursStr}:${minutes}:${seconds} ${ampm}`;

            // Build reasons string (like plugin)
            let reasons = "";
            if (formData.reasons.rate) reasons += "Rate Lock, ";
            if (formData.reasons.totalLoanAmount) reasons += "Loan Amount, ";
            if (formData.reasons.program) reasons += "Loan Program, ";
            if (formData.reasons.recordingFees) reasons += "Recording Fees, ";
            // if (formData.reasons.transferTaxes) reasons += "Transfer Taxes, ";
            if (formData.reasons.appraisedValue) reasons += "Appraised Value, ";
            if (formData.reasons.loanPurpose) reasons += "Loan Purpose, ";
            // if (formData.reasons.mortgageInsurance) reasons += "Mortgage Insurance, ";
            if (formData.reasons.propertyType) reasons += "Property Type, ";
            if (formData.reasons.other) reasons += "Other, ";
            if (formData.reasons.term) reasons += "Term, ";
            if (formData.reasons.occupancy) reasons += "Occupancy, ";
            if (formData.reasons.salesPrice) reasons += "Sales Price, ";
            if (formData.reasons.lenderborrowerPaid) reasons += "Lender/Borrower Paid, ";
            if (reasons.length > 0) reasons = reasons.substring(0, reasons.length - 2);

            // Build sentence (like plugin)
            let sentence = `[${timestamp}] `;
            if (reasons) sentence += `Reason(s): ${reasons}. `;
            if (formData.dateOfChange) sentence += `Request Date: ${formData.dateOfChange}. `;
            if (formData.notes) sentence += `Request Notes: ${formData.notes}. `;
            if (userName) sentence += `Requested By: ${userName}. `;
            sentence += `Status: Cancelled.`;
            sentence += "\n";

            // Append to previous history
            const newHistory = prevHistory ? sentence + prevHistory : sentence;

            // Prepare fieldData to clear custom fields and append history
            const clearFieldData = [
                { id: "CX.COC.APPROVAL.HISTORY", value: newHistory },
                { id: "CX.COC.REASON.RATELOCK", value: "N" },
                { id: "CX.COC.REASON.LOANAMOUNT", value: "N" },
                { id: "CX.COC.REASON.LOANPROGRAM", value: "N" },
                { id: "CX.COC.REASON.FEEUPDATE", value: "N" },
                // { id: "CX.COC.REASON.TRANSFERTAX", value: "N" },
                { id: "CX.COC.REASON.APPRAISEDVAL", value: "N" },
                { id: "CX.COC.REASON.LOANPURPOSE", value: "N" },
                // { id: "CX.COC.REASON.MORTGAGEINS", value: "N" },
                { id: "CX.COC.REASON.PROPERTYTYPE", value: "N" },
                { id: "CX.COC.REASON.OTHER", value: "N" },
                { id: "CX.COC.REASON.TERM", value: "N" },
                { id: "CX.COC.REASON.OCCUPANCY", value: "N" },
                { id: "CX.COC.REASON.SALESPRICE", value: "N" },
                { id: "CX.COC.CHANGEDATE", value: "" },
                { id: "CX.COC.COMMENTS", value: "" },
                { id: "CX.COC.REQ.BY", value: "" },
                { id: "CX.COC.REASON.LENBORRPAID", value: "N" },
                { id: "CX.COC.APPROVAL.DATE", value: "" }
            ];
            await fieldWriter(token, loanId, clearFieldData);
            setStatus("new");
            setFormData(prev => ({
                ...prev,
                reasons: Object.fromEntries(Object.keys(prev.reasons).map(k => [k, false])),
                dateOfChange: new Date().toISOString().split('T')[0],
                notes: '',
            }));
            setRequestHistory(newHistory);
            setSuccessMessage("");
            setErrorMessage("");
        } catch (err) {
            setErrorMessage("Failed to cancel change request.");
        } finally {
            setLoading(false);
        }
    };

    const getToken = async () => {
        try {
            const tpoAuthObject = await window.elli.script.getObject("auth");
            const authCode = await tpoAuthObject.createAuthCode();
            const token = await getAccessToken(authCode);
            setToken(token);
        } catch (err) {
            console.error("Token fetch failed", err);
        }
        finally {
            setLoading(false);
        }
    };

    const handleReasonChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            reasons: {
                ...prev.reasons,
                [name]: checked,
            },
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name in formData.reasons) {
            setFormData((prev) => ({
                ...prev,
                reasons: {
                    ...prev.reasons,
                    [name]: value,
                },
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    const validateForm = () => {
        let isValid = true;
        const errors = { reasons: "", dateOfChange: "" };

        const isAnyReasonSelected = Object.values(formData.reasons).some((val) => val);
        if (!isAnyReasonSelected) {
            errors.reasons = "Please select at least one reason.";
            isValid = false;
        }

        if (!formData.dateOfChange) {
            errors.dateOfChange = "Change request date is required.";
            isValid = false;
        }

        if (!formData.notes) {
            errors.notes = "Change notes is required";
            isValid = false;
        }

        setErrorMessages(errors);
        return isValid;
    };
    const handleSubmit = async () => {
        if (!validateForm()) return;

        setLoading(true);
        const fieldData = [
            {
                id: "CX.COC.REASON.RATELOCK",
                value: formData.reasons.rate ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.LOANAMOUNT",
                value: formData.reasons.totalLoanAmount ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.LOANPROGRAM",
                value: formData.reasons.program ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.FEEUPDATE",
                value: formData.reasons.recordingFees ? 'Y' : 'N'
            },
            // {
            //     id: "CX.COC.REASON.TRANSFERTAX",
            //     value: formData.reasons.transferTaxes ? 'Y' : 'N'
            // },
            {
                id: "CX.COC.REASON.APPRAISEDVAL",
                value: formData.reasons.appraisedValue ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.LOANPURPOSE",
                value: formData.reasons.loanPurpose ? 'Y' : 'N'
            },
            // {
            //     id: "CX.COC.REASON.MORTGAGEINS",
            //     value: formData.reasons.mortgageInsurance ? 'Y' : 'N'
            // },
            {
                id: "CX.COC.REASON.PROPERTYTYPE",
                value: formData.reasons.propertyType ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.OTHER",
                value: formData.reasons.other ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.TERM",
                value: formData.reasons.term ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.OCCUPANCY",
                value: formData.reasons.occupancy ? 'Y' : 'N'
            },
            {
                id: "CX.COC.REASON.SALESPRICE",
                value: formData.reasons.salesPrice ? 'Y' : 'N'
            },
            {
                id: "CX.COC.CHANGEDATE",
                value: formData.dateOfChange
            },
            {
                id: "CX.COC.COMMENTS",
                value: formData.notes
            },
            {
                id: "CX.COC.REQ.BY",
                value: userName
            },
            {
                id: "CX.COC.REASON.LENBORRPAID",
                value: formData.reasons.lenderborrowerPaid ? 'Y' : 'N'
            }
        ];
        //updating the custom field values
        info("COC custom field data added", { loanid: loanId });
        try {
            await fieldWriter(token, loanId, fieldData);
        } catch (err) {
            const rawDetails = err?.response?.data?.details || err.message || "Field update failed.";
            setErrorMessage(rawDetails);
            console.error("FieldWriter error:", rawDetails);
            setTimeout(() => {
                setErrorMessage("");
            }, 3000);
            setLoading(false);
            return;
        }

        const descriptionParts = [
            `Loan Amount: ${formData.reasons.totalLoanAmount ? 'Yes' : 'No'}`,
            `Rate: ${formData.reasons.rate ? 'Yes' : 'No'}`,
            // `Transfer Taxes: ${formData.reasons.transferTaxes ? 'Yes' : 'No'}`,
            `Appraised Value: ${formData.reasons.appraisedValue ? 'Yes' : 'No'}`,
            `Loan Purpose: ${formData.reasons.loanPurpose ? 'Yes' : 'No'}`,
            // `Mortgage Insurance: ${formData.reasons.mortgageInsurance ? 'Yes' : 'No'}`,
            `Program: ${formData.reasons.program ? 'Yes' : 'No'}`,
            `Property Type: ${formData.reasons.propertyType ? 'Yes' : 'No'}`,
            `Other: ${formData.reasons.other ? 'Yes' : 'No'}`,
            `Term: ${formData.reasons.term ? 'Yes' : 'No'}`,
            `Occupancy: ${formData.reasons.occupancy ? 'Yes' : 'No'}`,
            `Sales Price: ${formData.reasons.salesPrice ? 'Yes' : 'No'}`,
            `Recording Fees: ${formData.reasons.recordingFees ? 'Yes' : 'No'}`,
            `Date of Change: ${formData.dateOfChange}`,
            `Notes: ${formData.notes || 'N/A'}`,
            `Lender/Borrower Paid: ${formData.reasons.lenderborrowerPaid ? 'Yes' : 'No'}`
        ];
        const taskDescription = descriptionParts.join(" | ");
        //For creating a standalone task
        const tpoAuthObject = await window.elli.script.getObject("auth");
        tpoAuthObject.getUser().then(async function (user) {
            const authCode = await tpoAuthObject.createAuthCode();
            const url = `${API_DOMAIN}/api/support/create-task`;
            try {
                const formDataWithAuth = {
                    authCode: authCode,
                    loanId: loanId,
                    TaskName: `Broker Change Request - ${loanNumber}`,
                    TaskDescription: taskDescription
                };
                const response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formDataWithAuth),
                });

                const result = await response.json();

                if (response.ok) {
                    setSuccessMessage("Success");
                    setRequestChangeDate(formData.dateOfChange); // Update local state
                    setStatus("pending");
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                } else {
                    // Show server error (e.g. 403, 500, etc.)
                    setErrorMessage(result.message || `Failed with status ${response.status}`);
                }
            } catch (err) {
                setErrorMessage(`Unexpected error: ${err.message}`);
            } finally {
                setLoading(false);
                setTimeout(() => {
                    setErrorMessage("");
                    setSuccessMessage("");
                }, 3000);
            }
        });
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            {successMessage && (
                <div className="fixed top-6 right-6 z-50 flex items-start gap-3 bg-green-100 border-l-4 border-green-600 text-green-800 p-4 rounded-md shadow-lg max-w-sm animate-fade-in">
                    <div className="text-2xl">✅</div>
                    <div className="flex-1">
                        <div className="font-semibold mb-1">Success</div>
                        <div className="text-sm leading-relaxed break-words">{successMessage}</div>
                    </div>
                    <button
                        onClick={() => setSuccessMessage('')}
                        className="ml-4 text-green-500 hover:text-green-700 focus:outline-none transition-colors duration-200"
                        aria-label="Close"
                    >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            )}

            {errorMessage && (
                <div className="fixed top-6 right-6 z-50 flex items-start gap-3 bg-red-100 border-l-4 border-red-600 text-red-800 p-4 rounded-md shadow-lg max-w-sm animate-fade-in">
                    <div className="text-2xl">❌</div>
                    <div className="flex-1">
                        <div className="font-semibold mb-1">Error</div>
                        <div className="text-sm leading-relaxed break-words">{errorMessage}</div>
                    </div>
                    <button
                        onClick={() => setErrorMessage('')}
                        className="ml-4 text-red-500 hover:text-red-700 focus:outline-none transition-colors duration-200"
                        aria-label="Close"
                    >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            )}

            <div className="space-y-1 p-25px">
                <div className="bg-[var(--white)] rounded-lg p-3 space-y-6 max-w-8xl mx-auto">
                    <h2 className="page-title">Change Request</h2>
                    {status === "approved" && (
                        <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9]">
                            <div className="section-header">Change Request Status</div>
                            <div className="bg-white rounded-lg shadow-xl w-full max-w-8xl p-4 overflow-auto">
                                <div className="flex items-start">
                                    <span className="text-green-500 mr-2 mt-0.5">✔</span>
                                    <p className="form-label mb-1">
                                        Your change request has been <strong>approved</strong>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {status === "pending" && (
                        <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9]">
                            <div className="section-header">Change Request Status</div>
                            <div className="bg-white rounded-lg shadow-xl w-full max-w-8xl p-4 overflow-auto" style={{ pointerEvents: 'none' }}>
                                <div className="flex items-start mb-4">
                                    <span className="text-green-500 mr-2 mt-0.5">✓</span>
                                    <div className="form-label mb-1">
                                        <p>You have already submitted a change request. It is pending for approval.</p>
                                        <p>If you would like to cancel this request, please click the "Cancel Change Request" button below.</p>
                                        <p><b>NOTE:</b> Please review it before cancelling. Once cancelled, you may submit a new change request.</p>
                                    </div>
                                </div>
                                {/* Read-only submitted data */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div>
                                        <label className="form-label font-semibold">Date of Requested Change:</label>
                                        <input
                                            type="date"
                                            name="dateOfChange"
                                            value={formData.dateOfChange}
                                            readOnly
                                            className="border border-gray-300 rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed"
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label font-semibold">Loan Number:</label>
                                        <input
                                            type="text"
                                            name="loanNumber"
                                            value={formData.loanNumber || ''}
                                            readOnly
                                            className="border border-gray-300 rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed"
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label font-semibold">Borrower(s) Name:</label>
                                        <input
                                            type="text"
                                            name="borrowerName"
                                            value={formData.borrowerName || ''}
                                            readOnly
                                            className="border border-gray-300 rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed"
                                        />
                                    </div>
                                </div>
                                <div className="mb-4 text-xs text-gray-700">
                                    Lender accepted change of circumstance may be subject to underwriter and lock desk review. Failure to meet program guidelines will require additional redisclosure be sent.
                                </div>
                                <div className="mb-4">
                                    <label className="form-label mb-2 font-semibold">
                                        Reason(s) submitted:
                                    </label>
                                    <ReasonGrid reasons={formData.reasons} readOnly={true} loanTypeValue={loanTypeValue} />
                                </div>
                                <div className="mb-6">
                                    <label className="form-label mb-1 font-semibold">Notes:</label>
                                    <textarea
                                        name="notes"
                                        value={formData.notes}
                                        readOnly
                                        rows={4}
                                        className="w-full border border-gray-300 rounded px-3 py-2 resize-none bg-gray-100 cursor-not-allowed"
                                    />
                                </div>
                                {/* Overlay to block pointer events for all children except the cancel button */}
                                <div style={{ position: 'absolute', inset: 0, zIndex: 10, pointerEvents: 'auto', background: 'transparent' }} />
                                <div className="flex justify-end" style={{ pointerEvents: 'auto', position: 'relative', zIndex: 20 }}>
                                    <button
                                        onClick={handleCancel}
                                        className="btn-custom rounded text-white bg-red-500 hover:bg-red-700 transition-colors duration-200 px-4 py-2"
                                    >
                                        Cancel Change Request
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {status === "new" && (
                        <>
                            <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9]">
                                <div className="section-header">Details of Requested Change</div>
                                <div className="bg-white rounded-lg shadow-xl w-full max-w-8xl p-4 overflow-auto">
                                    {/* Top Row: Date, Loan Number, Borrower Name */}
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" style={{ pointerEvents: 'none' }}>
                                        <div>
                                            <label className="form-label font-semibold">Date of Requested Change:</label>
                                            <input
                                                type="date"
                                                name="dateOfChange"
                                                value={formData.dateOfChange}
                                                onChange={handleInputChange}
                                                className="border border-gray-300 rounded px-3 py-2 w-full"
                                                readOnly
                                            />
                                            {errorMessages.dateOfChange && (
                                                <p className="text-red-500 text-sm mt-1">{errorMessages.dateOfChange}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className="form-label font-semibold">Loan Number:</label>
                                            <input
                                                type="text"
                                                name="loanNumber"
                                                value={formData.loanNumber || ''}
                                                onChange={handleInputChange}
                                                className="border border-gray-300 rounded px-3 py-2 w-full"
                                                readOnly
                                            />
                                            {errorMessages.loanNumber && (
                                                <p className="text-red-500 text-sm mt-1">{errorMessages.loanNumber}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className="form-label font-semibold">Borrower(s) Name:</label>
                                            <input
                                                type="text"
                                                name="borrowerName"
                                                value={formData.borrowerName || ''}
                                                onChange={handleInputChange}
                                                className="border border-gray-300 rounded px-3 py-2 w-full"
                                                readOnly
                                            />
                                            {errorMessages.borrowerName && (
                                                <p className="text-red-500 text-sm mt-1">{errorMessages.borrowerName}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="mb-4 text-xs text-gray-700">
                                        Lender accepted change of circumstance may be subject to underwriter and lock desk review. Failure to meet program guidelines will require additional redisclosure be sent.
                                    </div>
                                    {/* Reason for Change - Grid Layout */}
                                    <div className="mb-4">
                                        <label className="form-label mb-2 font-semibold">
                                            Please choose the following reason(s) that changed or was found to be inaccurate:
                                        </label>
                                        <ReasonGrid reasons={formData.reasons} onChange={handleReasonChange} readOnly={false} loanTypeValue={loanTypeValue} />
                                        {errorMessages.reasons && (
                                            <p className="text-red-500 text-sm mt-1">{errorMessages.reasons}</p>
                                        )}
                                    </div>
                                    {/* Notes */}
                                    <div className="mb-6">
                                        <label className="form-label mb-1 font-semibold">Notes:<span className="text-red-500">*</span></label>
                                        <textarea
                                            name="notes"
                                            value={formData.notes}
                                            onChange={handleInputChange}
                                            rows={4}
                                            placeholder="Enter additional details..."
                                            className="w-full border border-gray-300 rounded px-3 py-2 resize-none"
                                        />
                                        {errorMessages.notes && (
                                            <p className="text-red-500 text-sm mt-1">{errorMessages.notes}</p>
                                        )}
                                    </div>
                                    {/* Submit button */}
                                    <div className="flex justify-end">
                                        <button
                                            onClick={handleSubmit}
                                            className="btn-custom rounded text-white bg-[#2080C3] hover:text-[#E6EEF8] hover:bg-[#5DA5D9] active:bg-white transition-colors duration-200 px-4 py-2"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {requestHistory && (
                        <div className="mb-4 ">
                            <label className="mb-1 pl-1 py-2 pt-4 pb-4 font-bold block">
                                Change Request History:
                            </label>

                            <textarea
                                name="notes"
                                value={requestHistory}
                                disabled
                                rows={6}
                                className="w-full border border-gray-300 rounded px-3 py-2 resize-none"
                            />
                        </div>
                    )}
                </div>
            </div >

        </>
    );
};

export default LoanChangeFormUpdated;
